module.exports = __webpack_public_path__ + "img/cns_ios15.c62303c2.png";